import { getApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';

export type TeamSearchSortBy =
  | 'teamId'
  | 'name'
  | 'csm'
  | 'lastBackfilled'
  | 'archivedAt'
  | 'dataDeletionScheduledDate'
  | 'dataDeletionExecutedOnDate'
  | 'developerApproved'
  | 'supportApproved'
  | 'ddiEnabled'
  | 'openApiEnabled'
  | 'ssoEnabled'
  | 'internalTestTeam';

export type TeamSearchSortOrder = 'ASC' | 'DESC';

export interface SearchTeamsByFieldsPayload {
  tenant?: string;
  realmId?: string;
  teamId?: string;
  csm?: string;
  teamIds?: string[];
  teamIdsNot?: string[];
  tags?: string[];
  integrations?: string[];
  ssoEnabled?: boolean;
  openApiEnabled?: boolean;
  ddiEnabled?: boolean;
  internalTestTeam?: boolean;
  chelloCompliant?: boolean;
  aiEnabled?: boolean;
  aiBlocked?: boolean;
  personal?: boolean;
  discarded?: boolean;
  text?: string;
  page?: number;
  limit?: number;
  sortBy?: TeamSearchSortBy;
  sortOrder?: TeamSearchSortOrder;
  deletionScheduled?: boolean;
  deactivationScheduled?: boolean;
  dataDeleted?: boolean;
  all?: boolean;
}

export interface TeamSearchIntegration {
  archivedAt: string | null;
  targetService: string;
  targetServiceId: number;
  state: string;
  deletionInProgress?: boolean;
}

export interface TeamSearchItem {
  id: string;
  tenant: string;
  realmId: string;
  teamId: string;
  name: string;
  integrations?: (string | TeamSearchIntegration)[] | null;
  ssoEnabled: boolean;
  openApiEnabled: boolean;
  csm?: string | null;
  tags?: string[] | null;
  nicknames?: string[] | null;
  internalTestTeam: boolean;
  ddiEnabled: boolean;
  // Optional: absent on galaxy-server versions predating BE-11564.
  chelloCompliant?: boolean;
  aiEnabled?: boolean;
  // Optional: absent on galaxy-server versions predating the AI block.
  aiBlocked?: boolean;
  dataDeletionScheduledDate?: string | null;
  dataDeletionExecutedOnDate?: string | null;
  developerApproved: boolean;
  developerApprover?: string | null;
  developerApprovedAt?: string | null;
  supportApproved: boolean;
  supportApprover?: string | null;
  supportApprovedAt?: string | null;
  lastBackfilled: string;
  archivedAt?: string | null;
  reasonToArchive?: string | null;
  scheduledArchiveDate?: string | null;
  realmArchived?: boolean;
}

export interface SearchTeamsByFieldsResponse {
  data: TeamSearchItem[];
  total: number;
  page: number;
  limit: number;
}

export const searchTeamsByFieldsApi = ({
  params,
  token,
  config,
}: BaseApiParams<SearchTeamsByFieldsPayload>) => {
  // Build custom headers if tenant/realmId are provided in params to override global cache
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  return getApiGalaxyServer<SearchTeamsByFieldsResponse>(
    `/lookup/teams/searchByFields`,
    {
      ...config,
      params: params as any,
      ...(customHeaders && { headers: customHeaders }),
    },
    token,
  );
};
